import {
    BTGPatientType
} from 'one-state-btgpatient/src/model';
/**
 * This Function transforms the backend response
 * in the Data Model that supports the
 * Epic User Id Component
 * @param response has the backend
 * Epic User Id  component response
 * @param context has settings etc..
 */

export const TransformResponse = (response: any, context: any,payloadRequest:any) => {
    /**
     * @param result contains the transformed response
     */
    let result: any = {
        patientbtgdata: {},
        error: undefined
    }

    const { log, settings:
        {
            epicendpoints: { searchID },
            uisettings:{btg_config:{btgenable}}, 
        } } = context;
        

    function addGenderIdentity(newEntry: any) {
        // 1. Get existing array from sessionStorage
        let stored = JSON.parse(sessionStorage.getItem("genderIdentity")) || [];

        // 2. Merge new entry
        let merged = [...stored, newEntry];

        // 3. Keep unique by patientid
        let unique = Array.from(
            new Map(merged.map(item => [item.patientid, item])).values()
        );

        // 4. Save back to sessionStorage
        sessionStorage.setItem("genderIdentity", JSON.stringify(unique));
        // 5. Also update Redux state (dispatch must be available in scope)
        if (typeof window !== "undefined" && (window as any).store) {
            (window as any).store.dispatch({ type: "ADD_GENDER_IDENTITY", payload: unique });
        }
    }
          function hasIdentifierValue(btgidentifier:any, searchvalue:any) {
            return btgidentifier.some((item:any)=> item.value === searchvalue || item.valueString === searchvalue);
          }
    if (response && (response.status >= 400 || response.type == "error")) {
        result.error = response;
    }
    else {
        let searchobj: BTGPatientType = {
            resourceType: "Patient"
        };
        if(btgenable){
        if (response?.output?.results?.length > 0) {
            response.output.results.forEach((btginfo: any) => {
                if (btginfo?.OperationOutcome) {
                    searchobj.resourceType = "OperationOutcome"
                }
                else{
                    let btgidentifier=btginfo?.Identifier;
                    let searchvalue=payloadRequest?.identifier
     
                   
                   if(hasIdentifierValue(btgidentifier,searchvalue)){
                   let genderIdentity=  {
                         "patientid":payloadRequest?.identifier,
                         "genderIdentity_birthSexCode":btginfo?.GenderExtension?.birthSexCode?btginfo?.GenderExtension?.birthSexCode:"",
                         "genderIdentity_birthSexText":btginfo?.GenderExtension?.birthSexText?btginfo?.GenderExtension?.birthSexText:""
                     }
                     addGenderIdentity(genderIdentity)
                   }
                }
            })
        }
    }
    else{
        if (response?.output?.results?.length > 0) { 
            response.output.results.forEach((btginfo: any) => {
               let btgidentifier=btginfo?.Identifier;
               let searchvalue=payloadRequest?.identifier

              
              if(hasIdentifierValue(btgidentifier,searchvalue)){
              let genderIdentity=  {
                    "patientid":payloadRequest?.identifier,
                    "genderIdentity_birthSexCode":btginfo?.GenderExtension?.birthSexCode?btginfo?.GenderExtension?.birthSexCode:"",
                    "genderIdentity_birthSexText":btginfo?.GenderExtension?.birthSexText?btginfo?.GenderExtension?.birthSexText:""
                }
                addGenderIdentity(genderIdentity)
              }
            })
        } 
    }
        result.patientbtgdata = searchobj
        log.debug(
            "ccw-gadget,Agent-epic",
            "Agent-epic transformation response ", {
            result
        });
    }
    return result;
}